export default {
  banner: {
    title1: "Authing already supports",
    title2: "users for secure login",
    subtitle:
      "We provide a platform for people to innovate through productivity technology",
    intro: {
      title: "A developer-centric, full-scene identity cloud product",
      descript:
        "The first developer-centric full-scene identity cloud product in China integrates all mainstream authentication protocols to provide complete and secure user authentication and access management services for enterprises and developers.",
      descript1: `Authing was recognized by the Ministry of Science and Technology as a "2020 National High-Tech Enterprise", selected as an "Innovative Enterprise in Domestic Identity Management and Access Control", and entered into the "2019 Cyber Security Industry White Paper".`,
      descript2: `In August 2021, Authing was listed in Forbes Asia's "Top 100 Companies to Watch" list, and in September 2021, Authing was successfully selected as one of the "Zhuoxin Big Data Program" by China Academy of Information and Communication Research.`,
      descript3:
        "Today, Authing has more than 200 employees worldwide and has built efficient office processes and secure IT management systems for domestic and international companies such as PetroChina, State Grid, Yuanqi Forest, China Merchants Bank, Toyota Japan, and JCDecaux.",
    },
  },
  process: {
    item1: {
      date: "2019.06",
      text: "公司成立，并获得硅谷著名孵化器「PLUG and PLAY」种子轮投资",
      textEn:
        "Authing was founded and received a seed round investment from the famous Silicon Valley incubator PLUG and PLAY.",
    },
    item2: {
      date: "2019.12",
      text: "被收录至「2019 年网络安全产业报告」安全产品全景图",
      textEn: `Included in the "2019 Cybersecurity Industry Report" security product panorama.`,
    },
    item3: {
      date: "2020.02",
      text: "获得「华创资本」和陆奇博士领导的「奇绩创坛」近千万元天使轮投资",
      textEn: `Received an angel round investment of nearly 10 million RMB from China Growth Capital and Miracleplus (YC China).`,
    },
    item4: {
      date: "2021.01",
      text: "获得「GGV 纪源资本」500 万美元 Pre-A 轮投资",
      textEn: `Received $5 million in Pre-A round of investment from GGV Capital.`,
    },
    item5: {
      date: "2021.08",
      text: "入选福布斯亚洲「最值得关注公司」百强榜单",
      textEn: `2021 "Forbes Asia 100 To Watch".`,
    },
    item6: {
      date: "2021.10",
      text:
        "获得由「老虎环球基金」领投，「鼎晖 VGC」、「声网 Agora」、「GGV 纪源资本」和「奇绩创坛」跟投，共计 2300 万美元 A 轮投资",
      textEn: `Series A investment led by Tiger Global Fund and followed by CDH VGC, Agora, GGV Capital and Miracleplus for a total of $23 million.`,
    },
    item7: {
      date: "Future",
      text: "连接全球人与应用",
      textEn: `Connect every person and app on the planet.`,
    },
  },
  future: {
    title: "Our future",
    item1: {
      title: "Authing Mission",
      subtitle: `“让身份像水电一样即需即用”`,
      subtitleEn: `Let identity be like water and electricity`,
    },
    item2: {
      title: "Authing Vision",
      subtitle: `“连接全球人与应用”`,
      subtitleEn: `Connect every person and app on the planet`,
    },
    item3: {
      title: "Authing Product",
      subtitle: `“以开发者为中心”`,
      subtitleEn: `Developer-centric`,
    },
    item4: {
      title: "Authing Service",
      subtitle: `“客户的成功，就是 Authing 的成功”`,
      subtitleEn: `The success of our customers is the success of Authing`,
    },
  },
  join: {
    title: "Join Authing and navigate the identity challenge with us",
    total: "Headquarters",
    nation: "National",
    citys: "5 cities",
    found: "Authing established",
    partner: "Authinger Members",
    connect: "Connected Applications",
    server: "Number of user services",
    beijing: "Beijing",
    shanghai: "Shanghai",
    shenzhen: "Shenzhen",
    chendu: "Chendu",
    wuhan: "Wuhan",
    address: "16 / F, Block B, NORTH STAR CENTURY CENTER, Beijing",
    button: "Join Us",
  },
  cutomer: {
    title: "From Startup to Industry No.1",
    subtitle:
      "Authing has helped 1200+ companies and tens of thousands of developers to build their user identity systems",
  },
};
